import { useTranslation } from "react-i18next"
import { useParams } from "react-router"
import { Suspense } from "react"
import { PeriodType } from "@/types"
import { badgeStatusVariants } from "@/feature/financial-model/constants"
import { Skeleton } from "@/components/ui/skeleton"
import { useGetCogsSuspenseSettings } from "../api"
import {
  NavigableSetUpCard,
  SetUpCardBadge,
  SetUpCardBody,
  SetUpCardContent,
  SetUpCardDescription,
  SetUpCardHeader,
  SetupCardIcon,
  SetUpCardTitle,
} from "@/components/shared/SetupCard"

type CogsCardsProps = {
  tab: PeriodType | "setup" | "totals"
}

export const CogsCards = ({ tab }: CogsCardsProps) => {
  const { id: financialModelId } = useParams<{ id: string }>()
  const { t } = useTranslation(`cogs`)
  const { t: commonT } = useTranslation(`common`)
  const { data: financialModelSettings } = useGetCogsSuspenseSettings({
    id: financialModelId!,
    module: `cogs`,
    section: tab === `totals` ? `setup` : tab,
  })

  return (
    <div className="grid grid-cols-2 gap-4">
      <NavigableSetUpCard
        className="h-full w-full"
        to={`/dashboard/financial-model/${financialModelId}/ecommerce/cogs/${tab}/direct-costs`}
      >
        <SetUpCardContent>
          <SetUpCardBody>
            <SetUpCardHeader>
              <SetUpCardTitle>
                {t(`cogs.home.cards.direct_costs.title`)}
              </SetUpCardTitle>
              <SetUpCardDescription>
                {t(`cogs.home.cards.direct_costs.description`)}
              </SetUpCardDescription>
            </SetUpCardHeader>
            {tab !== `totals` ? (
              <Suspense
                fallback={<Skeleton className="w-20 h-7 mt-4 rounded-full" />}
              >
                <SetUpCardBadge
                  variant={
                    badgeStatusVariants[
                      financialModelSettings.status.direct_costs
                    ]
                  }
                >
                  {commonT(
                    `bedges.${financialModelSettings.status.direct_costs}`
                  )}
                </SetUpCardBadge>
              </Suspense>
            ) : (
              <div className="mt-4 h-7" />
            )}
          </SetUpCardBody>
          <SetupCardIcon />
        </SetUpCardContent>
      </NavigableSetUpCard>

      <NavigableSetUpCard
        className="h-full w-full"
        to={`/dashboard/financial-model/${financialModelId}/ecommerce/cogs/${tab}/direct-labour`}
      >
        <SetUpCardContent>
          <SetUpCardBody>
            <SetUpCardHeader>
              <SetUpCardTitle>
                {t(`cogs.home.cards.direct_labour.title`)}
              </SetUpCardTitle>
              <SetUpCardDescription>
                {t(`cogs.home.cards.direct_labour.description`)}
              </SetUpCardDescription>
            </SetUpCardHeader>
            {tab !== `totals` ? (
              <Suspense
                fallback={<Skeleton className="w-20 h-7 mt-4 rounded-full" />}
              >
                <SetUpCardBadge
                  variant={
                    badgeStatusVariants[
                      financialModelSettings.status.direct_labour
                    ]
                  }
                >
                  {commonT(
                    `bedges.${financialModelSettings.status.direct_labour}`
                  )}
                </SetUpCardBadge>
              </Suspense>
            ) : (
              <div className="mt-4 h-7" />
            )}
          </SetUpCardBody>

          <SetupCardIcon />
        </SetUpCardContent>
      </NavigableSetUpCard>
    </div>
  )
}
